export const FacebookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="currentColor"
      className="h-6 w-6 opacity-80 transition-opacity duration-200 hover:opacity-100 lg:h-8 lg:w-8"
    >
      <path d="M16 0a16 16 0 0 0-2.5 31.81V20.62H9.44V16h4.06v-3.53c0-4 2.39-6.22 6-6.22a24.77 24.77 0 0 1 3.58.31v3.94h-2A2.31 2.31 0 0 0 18.5 13v3h4.44l-.71 4.62H18.5v11.19A16 16 0 0 0 16 0z"></path>
    </svg>
  );
};
